function BalanceCard({name,icon,amount}) {
    return (
      <div className="position-relative rounded-4 p-3" style={{backgroundColor: '#ffffff0d'}}>
        <div className="position-absolute d-flex align-items-center justify-content-center rounded-4 shadow" style={{height: '55px',width:'60px',top:'-20px',backgroundColor: '#ffffff18'}}>
            {icon}
        </div>
        <div className='ms-5 ps-4'>
            <h4 className='mb-0 fw-bolder'>{name}</h4>
            <p className='mb-4 fs-5'>{amount}</p>
        </div>
      </div>
    )
  }
  
  export default BalanceCard